import { IInfoCategoryMasterData } from '@Domains/MasterData';
import { Alert, Box, Skeleton, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useWatch } from 'react-hook-form';
import { useGreenhouseForm } from '../../EsgGreenhouseFormProvider';
import { IOtherDetailFormValues } from '../../EsgGreenhouseFormProvider/types';
import { useGreenhouseGoalTerm } from '../GreenhouseGoalTermProvider/GreenhouseGoalTermProvider';
import {
  OTHER_GH_VISIBILITY,
  OTHER_GREENHOUSE_COLUMNS,
} from './OtherGreenhouseColumns';

const mapOtherGreenhouseValues = (
  otherGreenhouses: IOtherDetailFormValues[],
  ghGasScope: IInfoCategoryMasterData[]
) => {
  return otherGreenhouses?.map((item, index) => {
    const scope = ghGasScope.find((scope) => scope.id === item.scopeId);

    return {
      ...item,
      id: item?.id ?? `NEW-${index + 1}`,
      scope: {
        infoCategoryMasterDataId: item.scopeId,
        nameTh: scope?.nameTh ?? '-',
        nameEn: scope?.nameEn ?? '-',
      },
    };
  });
};

const OtherGreenhouseTable = () => {
  const ghOtherDetails = useWatch({
    name: 'greenhouseGoalTerm.other.details',
  }) as Array<IOtherDetailFormValues>;

  const {
    formState: { errors },
  } = useGreenhouseForm();

  const { ghGasScope, loading, error } = useGreenhouseGoalTerm();

  if (loading) {
    return (
      <Box mt={3}>
        <Skeleton variant="rounded" height={100} sx={{ width: '100%' }} />
      </Box>
    );
  }

  if (error) {
    <Box mt={3}>
      <Alert severity="error">
        ไม่สามารถโหลดข้อมูลขอบเขตการปล่อยก๊าซเรือนกระจกได้
      </Alert>
    </Box>;
  }

  const initialGreenhouseValues = mapOtherGreenhouseValues(
    ghOtherDetails,
    ghGasScope ?? []
  );

  return (
    <Box mt={3}>
      <DataGrid
        rows={initialGreenhouseValues}
        columns={OTHER_GREENHOUSE_COLUMNS}
        getRowHeight={() => 'auto'}
        disableColumnSorting
        initialState={{
          columns: {
            columnVisibilityModel: OTHER_GH_VISIBILITY,
          },
        }}
      />
      {errors.greenhouseGoalTerm?.other?.details && (
        <Typography variant={'caption'} color={'error'}>
          {errors.greenhouseGoalTerm?.other?.details.message}
        </Typography>
      )}
    </Box>
  );
};

export default OtherGreenhouseTable;
